import { RootState } from 'src/store';
import { defaultFilterState, SampleReceptionFilterState } from './sampleReceptionSlice';

export const getSampleReceptionState = (state: RootState) => state.samples.sampleReception;

export const getSampleReceptionFilters = (state: RootState): SampleReceptionFilterState => {
    return getSampleReceptionState(state).filters || defaultFilterState;
};
